import * as React from "react";

import Button from "../../buttons/button/button";
import type {
    ModalFooterProps,
    StyledModalProps,
    ModelHeaderProps
} from "../modal";
import Modal, { ModalHeader, ModalFooter } from "../modal";

class ConfirmModal extends React.Component<StyledModalProps> {
    render() {
        const {
            padding,
            closeModal,
            size = `small`,
            type = `light`,
            height = `auto`,
            disableModalAutoClose
        } = this.props;

        return (
            <Modal
                {...this.props}
                padding={padding}
                closeModal={closeModal}
                size={size}
                type={type}
                height={height}
                disableModalAutoClose={disableModalAutoClose}
                header={({
                    title = `Confirm Modal`,
                    type,
                    imageSrc,
                    closeModal
                }: ModelHeaderProps) => (
                    <ModalHeader
                        title={title}
                        type={type}
                        imageSrc={imageSrc}
                        closeModal={closeModal}
                    />
                )}
                footer={({
                    closeIcon = `close`,
                    closeLabel,
                    confirmIcon = `cta-arrow-right`,
                    confirmLabel = `OK`,
                    type = `light`,
                    cancelButtonType = `outline`,
                    confirmButtonType = `primary`,
                    closeModal,
                    confirmCallback,
                    confirmDisabled,
                    confirmVisible = true
                }: ModalFooterProps) => (
                    <ModalFooter closeLabel={closeLabel}>
                        {closeLabel && (
                            <Button
                                type={cancelButtonType}
                                icon={closeIcon}
                                iconPosition="right"
                                onClick={closeModal}
                                aria-label={`close`}
                                darkTheme={type === `dark`}
                            >
                                {closeLabel}
                            </Button>
                        )}
                        {confirmVisible && (
                            <Button
                                type={confirmButtonType}
                                icon={confirmIcon}
                                iconPosition="right"
                                onClick={(e) => confirmCallback(e, closeModal)}
                                disabled={confirmDisabled}
                                aria-label={
                                    confirmDisabled
                                        ? `confirm-disabled`
                                        : `confirm`
                                }
                                data-testid={`confirm - ${confirmLabel}`}
                            >
                                {confirmLabel}
                            </Button>
                        )}
                    </ModalFooter>
                )}
            >
                {this.props.children}
            </Modal>
        );
    }
}

export default ConfirmModal;
